// Drafts: every save is kept here (IndexedDB, in this browser) BEFORE it goes
// to Dropbox and removed once Dropbox has it. So an edit made offline, while
// signed out, or just before a crash survives a reload, and the app saves it
// by itself when Dropbox is reachable again. IndexedDB, not localStorage: a
// diagram with a photo inside can be several MB.
//   { key, rel, baseRev, isPic, name, state, at }
const DB = 'cthdw-drafts';
const STORE = 'd';
let dbp = null;
function db() {
  if (!dbp) {
    dbp = new Promise((res, rej) => {
      const r = indexedDB.open(DB, 1);
      r.onupgradeneeded = () => r.result.createObjectStore(STORE, { keyPath: 'key' });
      r.onsuccess = () => res(r.result);
      r.onerror = () => { dbp = null; rej(r.error); };
    });
  }
  return dbp;
}
async function tx(mode, fn) {
  const d = await db();
  return new Promise((res, rej) => {
    const t = d.transaction(STORE, mode);
    const out = fn(t.objectStore(STORE));
    t.oncomplete = () => res(out && 'result' in out ? out.result : undefined);
    t.onerror = () => rej(t.error);
    t.onabort = () => rej(t.error);
  });
}
export const put = (draft) => tx('readwrite', (s) => s.put(draft));
export const get = (key) => tx('readonly', (s) => s.get(key));
export const del = (key) => tx('readwrite', (s) => s.delete(key));
export const all = () => tx('readonly', (s) => s.getAll());
